import React from 'react'
import SEO from 'src/components/common/SEO'
import FeatureBoxes from 'src/components/common/FeatureBoxesEs'
import { LogoSyncContextProvider } from 'src/components/common/AnnotationContext'
import {
  ChannelSection,
  FAQSection,
  HeroSection,
  Layout,
  PlatformSection,
} from 'src/components/common'

const SpainTemplateDefault = ({
  lang = 'es',
  market = 'spain',
  ctaText = 'COMENZAR 7 DÍAS GRATIS',
  // Metadata
  pageTitle,
  pageDescription,
  // Hero Section
  title,
  subtitle,
  tagline,
  video,
  staticAnnotation,
  annotations,
  poster,
}) => {
  let metaDescription =
    pageDescription ||
    'Disfruta de la mejor TV online. Las mejores series, dibujos infantiles de Nickelodeon y Nick Jr., realities de MTV, programas de entretenimiento para toda la familia y muchos más. En cualquier dispositivo: Ordenador, iOS, Android, Tablet…'

  return (
    <Layout lang={lang} market={market}>
      <LogoSyncContextProvider annotations={annotations}>
        <SEO lang={lang} market={market} title={pageTitle || title} description={metaDescription} />
        <HeroSection
          lang={lang}
          market={market}
          heroBgVideo={video}
          title={title}
          subtitle={subtitle}
          tagline={tagline}
          staticAnnotation={staticAnnotation}
          posterImg={poster}
          ctaText={ctaText}
        />
        <ChannelSection
          lang={lang}
          market={market}
          title={'AHORA PUEDES VER TUS CANALES FAVORITOS DE UNA FORMA DIFERENTE'}
          showAllChannels={true}
        />
        <FeatureBoxes />
        <PlatformSection lang={lang} market={market} ctaText={ctaText} />
        <FAQSection lang={lang} market={market} />
      </LogoSyncContextProvider>
    </Layout>
  )
}

export default SpainTemplateDefault
